import dictionaryRespository from '@/repositories/dictionary.repository'

class DictionarySerivice {
  async findAllLanguage () {
    const data = await dictionaryRespository.findAllLanguage();
    return data || [];
  }
  async findCoverPageContent (userType, language) {
    const data = await dictionaryRespository.findCoverPageContent(userType, language);
    return data || [];
  }
  async dictionaryCacheClean () {
    const data = await dictionaryRespository.dictionaryCacheClean();
    return data || [];
  }
  async findAllDictionary () {
    const data = await dictionaryRespository.findAllDictionary();
    return data || [];
  }
  async updateDictionary (dictionary) {
    const data = await dictionaryRespository.updateDictionary(dictionary);
    return data || [];
  }
  async findDicValue (cateGory, DicKey) {
    const data = await dictionaryRespository.findDicValue(cateGory, DicKey);
    return data || [];
  }
};

module.exports = new DictionarySerivice();



// WEBPACK FOOTER //
// ./src/services/dictionary.service.js